/** 
 * ELGEventEmitter
 * Simple Pub/Sub Emitter
 */

export class ELGEventEmitter {
    constructor(id, debug = false) {
        const eventList = new Map();

        this.on = (name, fn) => {
            if (!eventList.has(name)) eventList.set(name, this.pubSub());
            return eventList.get(name).sub(fn);
        };

        this.has = name => eventList.has(name);
        this.emit = (name, data) => eventList.has(name) && eventList.get(name).pub(data);
        this.dbg = debug ? console.log.bind(window.console, id || '') : () => { };
    }

    pubSub() {
        const subscribers = new Set();

        const sub = fn => {
            subscribers.add(fn);
            return () => {
                subscribers.delete(fn);
            };
        };

        const pub = data => subscribers.forEach(fn => fn(data));
        return Object.freeze({ pub, sub });
    }
}